/* uc-r3c-bundle-builder.js - the R3c layer on the UC bundle builder (OG-028, 17 Oct 2026).
 *
 * Runs after bundle-builder.js and never edits it. Per builder (window.bundleBuilders):
 *  - the cream "Your bundle" panel: picks, empty slots, RRP, the saving in pounds and the bundle price
 *  - the stepper (Pick n pieces, Choose sizes, Add to basket) and the add button's label
 *  - the phone foot bar with the same sums, pressing the builder's own add button
 *  - the Women's / Men's switch keeps each pick where the same piece (same name and colour) comes in the
 *    other fit in the same size, and drops it otherwise. The live builder kept hidden picks, so a men's
 *    piece could still go to the basket after a switch to women's.
 * RRP is compare-at where set, else the price (the live builder's own "original" total ignores compare-at).
 * Flexible bundles (Zack, 17 Oct 2026): the discount starts at the bundle's minimum and covers up to its maximum
 * (SupaEasy discounts at most `maximum` lines, in any group), so the panel shows no saving below the minimum and
 * the discount from it, picks may come from the same tab, and the builder stops at the maximum. Where minimum
 * equals maximum it reads as a fixed bundle ("Pick three pieces, 1 of 3"); a maximum of 10 (the record's top) is
 * SupaEasy's "no limit" and reads "three or more", "20% off every piece you add".
 */
(() => {
  const money = (c) => '£' + (c / 100).toFixed(c % 100 ? 2 : 0);
  const fitless = (t) => (t || '').replace(/^\s*(men'?s|women'?s)\s+/i, '').trim().toLowerCase();
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]));

  function sizeOf(sel) {
    const v = (sel.product.variants || []).find((x) => String(x.id) === String(sel.variant.id));
    return v ? JSON.stringify(v.options || []) : null;
  }

  function attach(root) {
    const b = window.bundleBuilders && window.bundleBuilders.get(root.dataset.sectionId);
    if (!b || root.dataset.ucR3c) return !!b;
    root.dataset.ucR3c = '1';
    const need = b.minimumProducts, max = Math.max(b.maximumProducts, b.minimumProducts), pct = b.discountSettings.percentage;
    const ranged = max > need, open = max >= 10;   // 10 = the record's top, SupaEasy "no limit" (uc_bundles.MO_NO_LIMIT)
    b.translations.buttons = Object.assign({}, b.translations.buttons, { bundleFull: 'Bundle full' });
    const q = (s) => root.querySelector(s);
    const picks = q('[data-uc-r3c-picks]'), steps = q('[data-uc-r3c-steps]'), foot = q('[data-uc-r3c-footbar]');
    const addBtn = q('.bundle-builder__add-to-cart'), footBtn = q('[data-uc-r3c-foot-btn]');

    function sums() {
      let rrp = 0, sub = 0;
      b.state.selectedProducts.forEach((s) => {
        const p = Number(s.variant && s.variant.price != null ? s.variant.price : s.price) || 0;
        const c = Number(s.variant && s.variant.compare_at_price) || 0;
        rrp += Math.max(c, p);
        sub += p;
      });
      const n = b.state.selectedProducts.size, ok = n >= need;
      // the board (R3c) shows the bundle price and saving as you build, before the last pick; the button says what is left
      const price = ok ? Math.round(sub * (1 - pct / 100)) : sub;
      return { n, rrp, price, saving: rrp - price, ok };
    }

    function render() {
      const t = sums();
      const sels = Array.from(b.state.selectedProducts.values());
      let html = sels.map((s) => {
        const v = (s.product.variants || []).find((x) => String(x.id) === String(s.variant.id));
        const size = v && v.options && v.options.length ? v.options.join(' / ') : '';
        return `<li class="uc-r3c-pick"><img src="${esc(s.product.featured_image)}" alt="" width="48" height="60">` +
          `<span class="uc-r3c-pick__text"><strong>${esc(s.product.title)}</strong>${size ? `<span>Size ${esc(size)}</span>` : ''}</span>` +
          `<strong>${money(Number(s.variant.price) || 0)}</strong>` +
          `<button type="button" class="uc-r3c-pick__remove" data-uc-r3c-remove="${esc(s.selectionKey)}" aria-label="Remove ${esc(s.product.title)}">&times;</button></li>`;
      }).join('');
      for (let i = t.n + 1; i <= Math.max(need, t.n); i++) {
        html += `<li class="uc-r3c-pick uc-r3c-pick--empty"><span class="uc-r3c-pick__slot"></span><span>Piece ${i}: choose from any tab</span></li>`;
      }
      if (t.n >= need && t.n < max) {
        html += `<li class="uc-r3c-pick uc-r3c-pick--empty uc-r3c-pick--optional"><span class="uc-r3c-pick__slot"></span><span>Piece ${t.n + 1} (optional): choose from any tab</span></li>`;
      }
      if (picks) picks.innerHTML = html;
      const set = (sel, v) => { const el = q(sel); if (el) el.textContent = v; };
      set('[data-uc-r3c-rrp]', money(t.rrp));
      set('[data-uc-r3c-saving]', money(t.saving));
      set('[data-uc-r3c-price]', money(t.price));
      set('[data-uc-r3c-count]', ranged ? `${t.n} picked` : `${Math.min(t.n, need)} of ${need}`);
      const label = t.n < need ? `Pick ${need - t.n} more` : 'Add to basket';
      set('[data-uc-r3c-status]', t.n < need ? `Add ${need - t.n} more for ${pct}% off.`
        : open && t.n < max ? `${pct}% off every piece you add.`
        : t.n < max ? `${pct}% off. You can add up to ${max - t.n} more.` : `${pct}% off. Your bundle is full.`);
      if (addBtn) addBtn.textContent = label;
      if (steps) {
        const sizing = !!b.state.currentSelectedProduct && t.n < max && !t.ok;
        const cur = t.ok && !sizing ? 3 : sizing ? 2 : 1;
        steps.querySelectorAll('li').forEach((li) => {
          const k = Number(li.dataset.step);
          li.classList.toggle('is-done', k < cur || (k === 1 && t.ok));
          if (k === cur) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
        });
      }
      if (foot) {
        foot.hidden = false;
        set('[data-uc-r3c-foot-count]', ranged ? `${t.n} picked` : `${t.n} of ${need}`);
        set('[data-uc-r3c-foot-rrp]', money(t.rrp));
        set('[data-uc-r3c-foot-price]', money(t.price));
        if (footBtn) { footBtn.textContent = label; footBtn.disabled = !addBtn || addBtn.disabled; }
      }
    }

    // picks may come from the same tab: the builder swaps out a same-tab pick, so set those aside around its add
    const add = b.addProductToBundle.bind(b);
    b.addProductToBundle = function (product, size) {
      if (b.state.selectedProducts.size >= max) { b.showError('Your bundle is full. Remove a piece to add another.'); return; }
      const gid = b.getCurrentGroupId();
      const all = Array.from(b.state.selectedProducts.entries());
      all.filter(([, s]) => s.groupId === gid).forEach(([k]) => b.state.selectedProducts.delete(k));
      const r = add(product, size);
      const added = Array.from(b.state.selectedProducts.entries()).filter(([k]) => !all.some(([k0]) => k0 === k));
      b.state.selectedProducts = new Map(all.concat(added));
      if (typeof b.updateProductGridSelection === 'function') b.updateProductGridSelection();
      b.updateUI();
      return r;
    };
    // stay on the tab after a pick, so a second piece can come from it; the empty slot says "any tab"
    b.advanceToNextEmptyGroup = function () {};

    // after every builder redraw
    const updateUI = b.updateUI.bind(b);
    b.updateUI = function (...args) { const r = updateUI(...args); try { render(); } catch (e) { console.error('uc-r3c', e); } return r; };
    root.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-uc-r3c-remove]');
      if (rm) { b.handleProductRemoval(rm.dataset.ucR3cRemove); render(); }
    });
    if (footBtn && addBtn) footBtn.addEventListener('click', () => addBtn.click());

    // Women's / Men's: keep each pick where the same piece comes in the other fit, drop it otherwise
    root.addEventListener('bundle:gender_changed', (e) => {
      if (e.target !== root) return;
      const g = e.detail && e.detail.selectedGender;
      let changed = false;
      Array.from(b.state.selectedProducts.entries()).forEach(([key, s]) => {
        const el = root.querySelector(`button.bundle-product-item[data-product-id="${s.product.id}"]`);
        const pg = el ? el.dataset.productGender : 'unisex';
        if (pg === 'unisex' || pg === g) return;
        b.state.selectedProducts.delete(key);
        changed = true;
        const want = fitless(s.product.title), size = sizeOf(s);
        const twin = Array.from(root.querySelectorAll(`button.bundle-product-item[data-group-id="${s.groupId}"]`))
          .find((x) => x.dataset.productGender === g && fitless(x.dataset.productTitle) === want);
        if (!twin || !size) return;
        const prod = b.getProductDataFromElement(twin);
        const v = (prod.variants || []).find((x) => x.available && JSON.stringify(x.options || []) === size);
        if (!v) return;
        const k = `${prod.id}_${v.id}`;
        b.state.selectedProducts.set(k, { selectionKey: k, groupId: s.groupId, product: prod,
          variant: { id: parseInt(v.id, 10), available: true, price: v.price, compare_at_price: v.compare_at_price },
          size: s.size, price: v.price });
      });
      if (changed) {
        if (typeof b.updateProductGridSelection === 'function') b.updateProductGridSelection();
        b.updateUI();
      }
    });
    render();
    return true;
  }

  function boot() {
    document.querySelectorAll('.bundle-builder.uc-r3c-builder').forEach((root) => {
      let tries = 0;
      const go = () => { if (!attach(root) && tries++ < 40) setTimeout(go, 100); };
      go();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
